var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.showCommunitySelector
            ? _c("community-selector", {
                attrs: { closable: _vm.isCommunitySelectorClosable },
                on: {
                  saved: _vm.onCommunitySelected,
                  close: function($event) {
                    _vm.showCommunitySelector = false
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "md-app",
        {
          staticClass: "full-height",
          class: { "content-blur": _vm.showCommunitySelector },
          attrs: { "md-waterfall": "", "md-mode": "fixed" }
        },
        [
          _c(
            "md-app-toolbar",
            { staticClass: "md-primary", attrs: { "md-elevation": 1 } },
            [
              _c(
                "header",
                { staticClass: "main-header" },
                [
                  _c(
                    "md-button",
                    {
                      staticClass: "md-icon-button",
                      attrs: { "aria-label": "Toggle navigation menu" },
                      on: { click: _vm.toggleMenu }
                    },
                    [
                      _c(
                        "md-icon",
                        [_c("font-awesome-icon", { attrs: { icon: "bars" } })],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "md-title" }, [
                    _vm._v("Protopia : Just Ask")
                  ]),
                  _c(
                    "md-button",
                    {
                      staticClass: "grab-request-btn",
                      on: {
                        click: function($event) {
                          return _vm.grabRequest()
                        }
                      }
                    },
                    [_c("b", [_vm._v("Grab Request")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "md-toolbar-section-end" },
                    [
                      _vm.communityName
                        ? _c(
                            "div",
                            { staticClass: "community-info" },
                            [
                              _c("span", { staticClass: "community-name" }, [
                                _vm._v(_vm._s(_vm.communityName))
                              ]),
                              _vm._v(" "),
                              _vm.canChangeCommunity
                                ? _c(
                                    "md-button",
                                    {
                                      staticClass: "change-community-btn",
                                      on: { click: _vm.changeCommunity }
                                    },
                                    [_vm._v("CHANGE COMMUNITY")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "md-menu",
                        { attrs: { "md-direction": "bottom-start" } },
                        [
                          _c(
                            "md-button",
                            {
                              attrs: {
                                "md-menu-trigger": "",
                                "aria-label": "User menu options"
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: "ellipsis-v" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "md-menu-content",
                            [
                              _c(
                                "md-menu-item",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.logout()
                                    }
                                  }
                                },
                                [_vm._v("LOGOUT")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "md-app-drawer",
            {
              staticClass: "md-scrollbar md-fixed sidebar-custom",
              attrs: { "md-active": _vm.menuVisible, "md-persistent": "full" },
              on: {
                "update:mdActive": function($event) {
                  _vm.menuVisible = $event
                },
                "update:md-active": function($event) {
                  _vm.menuVisible = $event
                }
              }
            },
            [
              _c(
                "nav",
                [
                  _c(
                    "md-list",
                    { staticClass: "app-sidebar" },
                    [
                      _c("div", { staticClass: "tiny-spacer" }),
                      _vm._v(" "),
                      _c("md-subheader", { staticClass: "nav-header" }, [
                        _vm._v("Asks")
                      ]),
                      _vm._v(" "),
                      _c(
                        "md-list-item",
                        {
                          staticClass: "nav-link",
                          attrs: { to: "/asks/search?term=my-request" },
                          on: { click: _vm.toggleMenu }
                        },
                        [
                          _vm._v(
                            "My Requests (" +
                              _vm._s(_vm.myRequestCount) +
                              ")\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "md-list-item",
                        {
                          staticClass: "nav-link",
                          attrs: { to: "/asks/all" },
                          on: { click: _vm.toggleMenu }
                        },
                        [
                          _vm._v(
                            "All (" +
                              _vm._s(_vm.getAllStatusCount()) +
                              ")\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.incompleteRequestCount > 0
                        ? _c(
                            "md-list-item",
                            {
                              staticClass: "nav-link",
                              attrs: { to: "/asks/incomplete-request" },
                              on: { click: _vm.toggleMenu }
                            },
                            [
                              _vm._v(
                                "Incomplete (" +
                                  _vm._s(_vm.incompleteRequestCount) +
                                  ")"
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.pendingObj.count > 0
                        ? _c(
                            "md-list-item",
                            {
                              staticClass: "nav-link",
                              attrs: {
                                to:
                                  "/asks/search?term=" +
                                  encodeURI(_vm.pendingObj.status)
                              },
                              on: { click: _vm.toggleMenu }
                            },
                            [
                              _vm._v(
                                "Pending (" + _vm._s(_vm.pendingObj.count) + ")"
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.newRequestsObj.count > 0
                        ? _c(
                            "md-list-item",
                            {
                              staticClass: "nav-link",
                              attrs: {
                                to:
                                  "/asks/search?term=" +
                                  encodeURI(_vm.newRequestsObj.status)
                              },
                              on: { click: _vm.toggleMenu }
                            },
                            [
                              _vm._v(
                                "New Requests (" +
                                  _vm._s(_vm.newRequestsObj.count) +
                                  ")"
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.reviewCount > 0
                        ? _c(
                            "md-list-item",
                            {
                              staticClass: "nav-link",
                              attrs: {
                                to: "/asks/search?term=" + encodeURI("Review")
                              },
                              on: { click: _vm.toggleMenu }
                            },
                            [_vm._v("Review (" + _vm._s(_vm.reviewCount) + ")")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.approvedCount > 0
                        ? _c(
                            "md-list-item",
                            {
                              staticClass: "nav-link",
                              attrs: {
                                to: "/asks/search?term=" + encodeURI("Approved")
                              },
                              on: { click: _vm.toggleMenu }
                            },
                            [
                              _vm._v(
                                "Approved (" + _vm._s(_vm.approvedCount) + ")"
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.tagObj.count > 0
                        ? _c(
                            "md-list-item",
                            {
                              staticClass: "nav-link",
                              attrs: {
                                to:
                                  "/asks/search?term=" +
                                  encodeURI(_vm.tagObj.status)
                              },
                              on: { click: _vm.toggleMenu }
                            },
                            [_vm._v("Tag (" + _vm._s(_vm.tagObj.count) + ")")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.matchObj.count > 0
                        ? _c(
                            "md-list-item",
                            {
                              staticClass: "nav-link",
                              attrs: {
                                to:
                                  "/asks/search?term=" +
                                  encodeURI(_vm.matchObj.status)
                              },
                              on: { click: _vm.toggleMenu }
                            },
                            [
                              _vm._v(
                                "Match (" + _vm._s(_vm.matchObj.count) + ")"
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "md-list-item",
                        {
                          staticClass: "nav-link",
                          attrs: { to: "/asks/pending-responses" },
                          on: { click: _vm.toggleMenu }
                        },
                        [
                          _vm._v(
                            "\n          Pending Responses (" +
                              _vm._s(_vm.pendingResponsesCount) +
                              ")\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.responseStatusCount > 0
                        ? _c(
                            "md-list-item",
                            {
                              staticClass: "nav-link",
                              attrs: { to: "/asks/responses" },
                              on: { click: _vm.toggleMenu }
                            },
                            [
                              _vm._v(
                                "New Responses (" +
                                  _vm._s(_vm.responseStatusCount) +
                                  ")"
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.activeCount > 0
                        ? _c(
                            "md-list-item",
                            {
                              staticClass: "nav-link",
                              attrs: {
                                to: "/asks/search?term=" + encodeURI("Active")
                              },
                              on: { click: _vm.toggleMenu }
                            },
                            [_vm._v("Active (" + _vm._s(_vm.activeCount) + ")")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.noResponseCount > 0
                        ? _c(
                            "md-list-item",
                            {
                              staticClass: "nav-link",
                              attrs: {
                                to:
                                  "/asks/search?term=" +
                                  encodeURI("no-response")
                              },
                              on: { click: _vm.toggleMenu }
                            },
                            [
                              _vm._v(
                                "No Response (" +
                                  _vm._s(_vm.noResponseCount) +
                                  ")"
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.closedObj.count > 0
                        ? _c(
                            "md-list-item",
                            {
                              staticClass: "nav-link",
                              attrs: {
                                to:
                                  "/asks/search?term=" +
                                  encodeURI(_vm.closedObj.status)
                              },
                              on: { click: _vm.toggleMenu }
                            },
                            [
                              _vm._v(
                                "Closed (" + _vm._s(_vm.closedObj.count) + ")"
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.rejectedObj.count > 0
                        ? _c(
                            "md-list-item",
                            {
                              staticClass: "nav-link",
                              attrs: {
                                to:
                                  "/asks/search?term=" +
                                  encodeURI(_vm.rejectedObj.status)
                              },
                              on: { click: _vm.toggleMenu }
                            },
                            [
                              _vm._v(
                                "Rejected (" +
                                  _vm._s(_vm.rejectedObj.count) +
                                  ")"
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "md-list-item",
                        [
                          _c(
                            "md-field",
                            { attrs: { "md-clearable": "" } },
                            [
                              _c("md-input", {
                                attrs: { placeholder: "Search Asks" },
                                on: {
                                  keyup: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.searchAsk(_vm.search)
                                  },
                                  input: function($event) {
                                    _vm.search = _vm.sanitizeInput($event)
                                  }
                                },
                                model: {
                                  value: _vm.search,
                                  callback: function($$v) {
                                    _vm.search = $$v
                                  },
                                  expression: "search"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("md-divider"),
                      _vm._v(" "),
                      _vm.isRecruitingAccessEnabled
                        ? [
                            _c("md-subheader", { staticClass: "nav-header" }, [
                              _vm._v("Recruiting")
                            ]),
                            _vm._v(" "),
                            _c(
                              "md-list-item",
                              {
                                staticClass: "nav-link",
                                attrs: { to: "/recruiting" },
                                on: { click: _vm.toggleMenu }
                              },
                              [
                                _vm._v(
                                  "All (" +
                                    _vm._s(_vm.recruitingCounts.all) +
                                    ")"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.recruitingCounts.active > 0
                              ? _c(
                                  "md-list-item",
                                  {
                                    staticClass: "nav-link",
                                    attrs: { to: "/recruiting?term=active" },
                                    on: { click: _vm.toggleMenu }
                                  },
                                  [
                                    _vm._v(
                                      "Approved (" +
                                        _vm._s(_vm.recruitingCounts.active) +
                                        ")"
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.recruitingCounts.closed > 0
                              ? _c(
                                  "md-list-item",
                                  {
                                    staticClass: "nav-link",
                                    attrs: { to: "/recruiting?term=closed" },
                                    on: { click: _vm.toggleMenu }
                                  },
                                  [
                                    _vm._v(
                                      "Closed (" +
                                        _vm._s(_vm.recruitingCounts.closed) +
                                        ")"
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.recruitingCounts.in_review > 0
                              ? _c(
                                  "md-list-item",
                                  {
                                    staticClass: "nav-link",
                                    attrs: { to: "/recruiting?term=in_review" },
                                    on: { click: _vm.toggleMenu }
                                  },
                                  [
                                    _vm._v(
                                      "In Review (" +
                                        _vm._s(_vm.recruitingCounts.in_review) +
                                        ")"
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.recruitingCounts.incomplete > 0
                              ? _c(
                                  "md-list-item",
                                  {
                                    staticClass: "nav-link",
                                    attrs: {
                                      to: "/recruiting?term=incomplete"
                                    },
                                    on: { click: _vm.toggleMenu }
                                  },
                                  [
                                    _vm._v(
                                      "Incomplete (" +
                                        _vm._s(
                                          _vm.recruitingCounts.incomplete
                                        ) +
                                        ")"
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.recruitingCounts.quarantined > 0
                              ? _c(
                                  "md-list-item",
                                  {
                                    staticClass: "nav-link",
                                    attrs: {
                                      to: "/recruiting?term=quarantined"
                                    },
                                    on: { click: _vm.toggleMenu }
                                  },
                                  [
                                    _vm._v(
                                      "Quarantined (" +
                                        _vm._s(
                                          _vm.recruitingCounts.quarantined
                                        ) +
                                        ")"
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.recruitingCounts.rejected > 0
                              ? _c(
                                  "md-list-item",
                                  {
                                    staticClass: "nav-link",
                                    attrs: { to: "/recruiting?term=rejected" },
                                    on: { click: _vm.toggleMenu }
                                  },
                                  [
                                    _vm._v(
                                      "Rejected (" +
                                        _vm._s(_vm.recruitingCounts.rejected) +
                                        ")"
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("md-divider")
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "nav-header-community" },
                        [
                          _c("md-subheader", { staticClass: "nav-header" }, [
                            _vm._v("Communities")
                          ]),
                          _vm._v(" "),
                          _c(
                            "md-field",
                            { staticClass: "m-left-5 nav-header-filter" },
                            [
                              _c(
                                "md-select",
                                {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  attrs: {
                                    name: "status",
                                    placeholder: "status",
                                    id: "status"
                                  },
                                  on: { "md-selected": _vm.communityFilter },
                                  model: {
                                    value: _vm.communityStatus,
                                    callback: function($$v) {
                                      _vm.communityStatus = $$v
                                    },
                                    expression: "communityStatus"
                                  }
                                },
                                [
                                  _c(
                                    "md-option",
                                    { attrs: { value: "Live_Preview" } },
                                    [_vm._v("Active & Preview")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-option",
                                    { attrs: { value: "Live" } },
                                    [_vm._v("Active")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-option",
                                    { attrs: { value: "Preview" } },
                                    [_vm._v("Preview")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-option",
                                    { attrs: { value: "Inactive" } },
                                    [_vm._v("Inactive")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.filterCommunities, function(community, index) {
                        return _vm.filterCommunities
                          ? [
                              _c(
                                "md-list-item",
                                {
                                  key: "community" + index,
                                  staticClass: "nav-link",
                                  on: {
                                    click: function($event) {
                                      return _vm.handleCommunityClick(community)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(community.name))]
                              )
                            ]
                          : _vm._e()
                      }),
                      _vm._v(" "),
                      _c(
                        "md-list-item",
                        {
                          staticClass: "nav-link",
                          attrs: { to: "/communities/create" },
                          on: { click: _vm.toggleMenu }
                        },
                        [_vm._v(" + Create Community")]
                      ),
                      _vm._v(" "),
                      _c("md-divider"),
                      _vm._v(" "),
                      _c("md-subheader", { staticClass: "nav-header" }, [
                        _vm._v("Members")
                      ]),
                      _vm._v(" "),
                      _c(
                        "md-list-item",
                        {
                          staticClass: "nav-link",
                          attrs: { to: "/members/all" },
                          on: { click: _vm.toggleMenu }
                        },
                        [_vm._v("All")]
                      ),
                      _vm._v(" "),
                      _c(
                        "md-list-item",
                        [
                          _c(
                            "md-field",
                            { attrs: { "md-clearable": "" } },
                            [
                              _c("md-input", {
                                attrs: {
                                  type: "text",
                                  placeholder: "Search Members"
                                },
                                on: {
                                  keyup: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.searchMembers(_vm.searchMember)
                                  },
                                  input: function($event) {
                                    _vm.searchMember = _vm.sanitizeInput($event)
                                  }
                                },
                                model: {
                                  value: _vm.searchMember,
                                  callback: function($$v) {
                                    _vm.searchMember = $$v
                                  },
                                  expression: "searchMember"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("md-divider", {
                        staticStyle: { "margin-top": "15px" }
                      }),
                      _vm._v(" "),
                      _c("md-subheader", { staticClass: "nav-header" }, [
                        _vm._v("General Setting")
                      ]),
                      _vm._v(" "),
                      [
                        _c(
                          "md-list-item",
                          {
                            staticClass: "nav-link",
                            attrs: { to: "/configuration/settings" },
                            on: { click: _vm.toggleMenu }
                          },
                          [_vm._v(_vm._s(_vm.displayName("Settings")))]
                        )
                      ],
                      _vm._v(" "),
                      _c("md-divider"),
                      _vm._v(" "),
                      _c("md-subheader", { staticClass: "nav-header" }, [
                        _vm._v("Email Templates")
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.sortTemplates, function(template) {
                        return Array.isArray(_vm.templates) &&
                          template.deleted !== true
                          ? [
                              _c(
                                "md-list-item",
                                {
                                  key: template._id,
                                  staticClass: "nav-link",
                                  attrs: { to: "/templates/" + template._id },
                                  on: { click: _vm.toggleMenu }
                                },
                                [
                                  _vm._v(
                                    _vm._s(template.name) + "\n\t          "
                                  )
                                ]
                              )
                            ]
                          : _vm._e()
                      }),
                      _vm._v(" "),
                      _c(
                        "md-list-item",
                        {
                          staticClass: "nav-link",
                          attrs: { to: "/templates/create" },
                          on: { click: _vm.toggleMenu }
                        },
                        [_vm._v(" + Create Template")]
                      ),
                      _vm._v(" "),
                      _c("md-subheader", { staticClass: "nav-header" }, [
                        _vm._v("SMS Templates")
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.sortSmsTemplates, function(smsTemplate) {
                        return Array.isArray(_vm.smsTemplates) &&
                          smsTemplate.deleted !== true
                          ? [
                              _c(
                                "md-list-item",
                                {
                                  key: smsTemplate._id,
                                  staticClass: "nav-link",
                                  attrs: {
                                    to: "/templates/sms/" + smsTemplate._id
                                  },
                                  on: { click: _vm.toggleMenu }
                                },
                                [
                                  _vm._v(
                                    _vm._s(smsTemplate.name) + "\n\t          "
                                  )
                                ]
                              )
                            ]
                          : _vm._e()
                      }),
                      _vm._v(" "),
                      _c(
                        "md-list-item",
                        {
                          staticClass: "nav-link",
                          attrs: { to: "/templates/sms/create" },
                          on: { click: _vm.toggleMenu }
                        },
                        [_vm._v(" + Create Template")]
                      ),
                      _vm._v(" "),
                      _c("md-divider"),
                      _vm._v(" "),
                      _c("md-subheader", { staticClass: "nav-header" }, [
                        _vm._v("Configuration")
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.configurations, function(
                        configuration,
                        index
                      ) {
                        return [
                          _c(
                            "md-list-item",
                            {
                              key: "configuration" + index,
                              staticClass: "nav-link",
                              attrs: {
                                to: "/configuration/reference-" + configuration
                              },
                              on: { click: _vm.toggleMenu }
                            },
                            [
                              _vm._v(
                                "Reference: " +
                                  _vm._s(_vm.displayName(configuration))
                              )
                            ]
                          )
                        ]
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "md-app-content",
            [
              _c(
                "vue-scroll",
                { ref: "vs", attrs: { ops: _vm.ops } },
                [
                  _vm.isCommunitySelected
                    ? _c("router-view", {
                        on: {
                          reload: _vm.loadData,
                          "response-count": _vm.updateResponseCount
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-005bfc5a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-005bfc5a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout.vue
// module id = null
// module chunks = 